<template>
    <div>
        <fieldset>
            <legend>Grupo4</legend>
            <div class="row" >
                <div class="input-field col s6">
                    <input type="text"  required  :disabled="!editable"  v-model="project.titulo" name="titulo" id="titulo" maxlength="200"/>
                    <label for="titulo" >Título da Ação</labeL>
                </div>
                <div class="input-field col s2">
                    <input type="text"  required :disabled="!editable"  
                    v-model="project['area_cnpq']"  maxlength="12" name="area_cnpq" v-mask="'#.##.##.##-#'" id="area_cnpq" />
                    <label for="area_cnpq">Código de área do CNPQ</label>
                </div>
                
                <div class="file-field input-field col s3" v-if="editable">
                    <div class="btn" >
                        <span>Ação</span>
                        <input type="file" :disabled="!editable" title=''  name="projeto"   ref="pdfProjeto" id="projeto" accept="application/pdf" />
                    </div>
                    <div class="file-path-wrapper">
                        <input class="file-path validate"  :disabled="!editable" 
                         :value="(( !$refs.pdfProjeto|| !$refs.pdfProjeto.files.length)?getNamePdf(project.pdf):$refs.pdfProjeto.files[0].name)" name="nome_pdf_projeto" type="text" />
                    </div>
                 
                </div>
                
                <div v-else>
                    <div class="input-field col s3">
                        <input type="text" disabled name="nome_pdf_projeto"/>
                    </div> 
                </div>
                <div v-if="project['id']" class="input-field col s1">
                    <a :href="'/projetos/pdf/'+project.id" target='_blank'>Ver PDF</a>
                </div>
                
            </div>
			
			<div class="row">
				<div class="input-field col s6">
                    <input type="text"   required :disabled="!editable"  v-model="project['instancia']" name="instancia" id="instancia" maxlength="200"/>
                    <label for="instancia">Instância que Aprovou a Ação</labeL>
                </div>
				<div class="input-field col s2">
                    <input type="date" required :disabled="!editable"  v-model="project['data_aprovacao']" name="data_aprovacao" id="data_aprovacao"/>
                    <label for="data_aprovacao">Data da Aprovação</labeL>
                </div>
				<div v-if="editable" class="file-field input-field col s3">
					<div class="btn">
						<span>Comprovante</span>
						<input type="file" title='' ref="comprovante" :id="'/comprovante/pdf/' + project.id" required accept="application/pdf">
					</div>
					<div class="file-path-wrapper">
						<input class="file-path validate" 
                        :value="(( !$refs.comprovante|| !$refs.comprovante.files.length)? getNamePdf(project.comprovante) :$refs.comprovante.files[0].name)"
                        id='comprovante' name='comprovante' type="text">
					</div>
				</div>
				<div class="input-field col s1">
					<label>
						<a v-if='project.id'   :id="'/comprovante/link-pdf/' + project.id" :href="'/comprovante/pdf/' + project.id" target='_blank'>Ver PDF</a>
						<a v-else :id="'/comprovante/link-pdf/' + project.id"  :href="'/comprovante/pdf/' + project.id" target='_blank'></a>
					</label>
				</div>
			</div>
			
            <div class="row">
                <div class="input-field col s8">
                    <textarea name="resumo" required  :disabled="!editable"  id="resumo" v-model="project['resumo']" class="materialize-textarea" maxlength="2000" data-length="2000"></textarea>
                    <label for="resumo">Resumo</label>
                </div>
                <div v-if="editable" class="file-field input-field col s3">
					<div class="btn">
						<span>Memorial</span>
						<input type="file" title='' name="memorial" ref="memorial" :id="'/memorial/pdf/' + project.id"
                            
                         required accept="application/pdf" >
					</div>
					<div class="file-path-wrapper">
						<input class="file-path validate" id='memorial' name='memorial' 
                        :value="(( !$refs.memorial|| !$refs.memorial.files.length)? getNamePdf(project.memorial) :$refs.memorial.files[0].name)"
                        type="text">
					</div>
				</div>
                <div class="input-field col s1">
					<label>
						<a v-if='project.id' :id="'/memorial/link-pdf/' + project.id" :href="'/projetos/' + project.id + '/memorialDownload'" target='_blank'>Ver PDF</a>
						<a v-else :id="'/memorial/link-pdf/' + project.id"  :href="'/projetos/' + project.id + '/memorialDownload'" target='_blank'></a>
					</label>
				</div>
            </div>
            <div class="row">
                <div class="input-field col s4">
                    <input type="text" :disabled="!editable"   v-model="project['palavras_chave']" name="palavras_chave" @keyup="limitarPalavrasChave()" id="palavras_chave" />
                    <label for="palavras_chave">Palavras-Chave(Utilize ; (ponto e vírgula) como seperador)</label>
                    
                </div>
                <div class="input-field col s1">
                    <input type="number" name="numero_bolsas" 
                    :value="(!project.bolsas || project.bolsas.length ==0)?1:project.bolsas.length"
                    :disabled="!editable"  id="numero_bolsas"
                     min="1" @keyup="_setNumBolsas($event)" :max="maxbolsas" required @mouseup="_setNumBolsas($event)" 
                     @change="_setNumBolsas($event)"/>
                    <label for="numero_bolsas">Bolsas</label>


                </div>
                <div class="input-field col s7">
                    <textarea name="justificativa"  :disabled="!editable"  v-model="justificativa" id="justificativaDoNumeroDeBolsas" 
                      class="active materialize-textarea" maxlength="2000" data-length="2000"></textarea>
                    <label for="justificativaDoNumeroDeBolsas">Justificativa de número de bolsas</label>
                </div>

            </div>
            <div class="row" v-if="project.bolsas.length >0 && this.editable != undefined">
                    <bolsa :projectid="project.id" :disabled="!this.editable"/>
                <div class="row">
                    <div class="col s12 m2 xl12">
                        <button  style="width:100%;" class="btn btn-large" :disabled="!editable" 
                            type="button" name="btnInscricao" id="btnInscricao" @click="btnInscricaoOnClick($event)">{{project.id?'Atualizar':'Inscrever-se'}} </button>
                    </div>
                </div>
            </div>
            
            
        </fieldset>
    </div>
</template>
<script>
import {mask} from 'vue-the-mask'
import Bolsa from '../Bolsa.vue';
import {validatePDF,verifyCpf,getNamePdf} from '../../utils.js';
import { mapState, mapActions, mapGetters } from 'vuex';
export default {
    name:'Group4',
    props:[
        'editable',
        'maxbolsas',
    ],
    directives: {mask},
    components:{
        Bolsa,
    },
    computed:{
        ...mapState(['project']),
       justificativa:{
           get(){
               return this.project.justificativa_bolsas;
           },
           set(value){
               this.$set(this.project,'justificativa_bolsas',value);
//               this.project.justificativa_bolsas=value;
               this.setProject(this.project);
           }
       }
        
    },
    methods:{
        ...mapActions(['setProject','setBolsas']),
        updateField(){
            setTimeout( ()=>{
                M.textareaAutoResize($('textarea'));
                M.updateTextFields();
                 $('textarea').characterCounter();
            },1000);
            
        },
        
        cnpqInput(e){
            if(e.target.value.length != 8){
                this.project.area_cnpq=e.target.value.replace(/[^0-9]/g,'');
                return false
            };
            this.project.area_cnpq=e.target.value;
            this.setProject(this.project);
            setTimeout( ()=>{
                this.$nextTick(()=>{
                    let value=e.target.value;
                    $("#area_cnpq").val(value.substring(0,1)
                    .concat('.')
                    .concat(value.substring(1,3)
                    .concat('.')
                    .concat(value.substring(3,5))
                    .concat(".")
                    .concat(value.substring(5,7))
                    .concat('-')
                    .concat(value.substring(7,8))
                    ));
                    
                    
                });
            },500);
            
        },
        verifyCpf:verifyCpf,
        validatePDF:validatePDF,
        getNamePdf,
        _addBolsa(){
          return {
                plano_trabalho:'',
                projeto_id:'',
                
            };
        },
        _setNumBolsas(e){
            let totalDeBolsas=this.$props.maxbolsas;
            let qtdBolsas=$("input[name='numero_bolsas']").val();
            
            if(!qtdBolsas)return false;
            if( Number(qtdBolsas) <=0 ||Number(qtdBolsas) > Number(totalDeBolsas)){
                showMsg("O número não pode ser maior que o total de bolsas");
                $("input[name='numero_bolsas']").val("1");
                
            }
            else{
                let qtdBolsasSelecionadas=this.project.bolsas.length;
                let diff=0;
                if(qtdBolsasSelecionadas > qtdBolsas)
                    for(let i=qtdBolsasSelecionadas;i> qtdBolsas;i--)
                        this.project.bolsas.splice(i-1,1);
                else{
                    diff=qtdBolsas-qtdBolsasSelecionadas;
                    for(let i=0;i<diff;i++){
                        this.project.bolsas.push(this._addBolsa());
                    }
                    
                }
                this.$set(this.project,'bolsas',this.project.bolsas);
                this.setBolsas(this.project.bolsas);;
                this.$nextTick();
                this.updateField();
                
                
            }
            
            
        },
       
        limitarPalavrasChave(){
            let limite =3;
            let input=$("input[name='palavras_chave']");
            let palavras=input.val().split(";");
            if(palavras.length > 3){
                showMsg("Por favor, insira no máximo até "+limite+" palavras.");
                input.val(palavras[0]+";"+palavras[1]+";"+palavras[2]);
                
            }
                
        },
         
        
       
        _validarForm(){
            
            if($("input[name='titulo']").val().trim().length ==0){
                showMsg('Por favor, insira um título');
                return false;
            }
            let area_cnpq=$("input[name='area_cnpq']").val();
            area_cnpq=area_cnpq.replace(/[^0-9]/g,'');
            if(area_cnpq.length < 8){
                showMsg('Por favor, insira o código do CNPQ com 8 caracteres');
                return false;
            }
			
			if($("input[name='instancia']").val().trim().length == 0){
                showMsg('Por favor, insira a instância que aprovou a ação');
                return false;
            }
			if($("input[name='data_aprovacao']").val().trim().length == 0){
                showMsg('Por favor, insira a data de aprovação da ação');
                return false;
            }
			if (document.getElementById('/comprovante/link-pdf/' + this.project.id).innerText != 'Ver PDF') {
				showMsg("Por favor, insira o comprovante da aprovação da ação");
				return false;
			}
			if (document.getElementById('/memorial/link-pdf/' + this.project.id).innerText != 'Ver PDF') {
				showMsg("Por favor, insira o memorial");
				return false;
			}
			
            if($("textarea[name='resumo']").val().trim().length ==0){
                showMsg('Por favor, insira um resumo');
                return false;
            }
            if($("textarea[name='justificativa']").val().trim().length ==0){
                showMsg('Por favor, insira uma justificativa');
                return false;
            }
            if($("input[name='palavras_chave']").val().trim().length ==0){
                showMsg("Por favor, insira pelo menos uma palavra-chave");
                return false;
            }
            if(this.project.bolsas.length == 0){
                showMsg("Por favor, insira pelo menos uma bolsa");
                return false;
            }
            else{
                
                let ok=this.project.bolsas.every( (bolsa,index)=>{
                    return bolsa.plano_trabalho.length>0;
                });
                
                if(!ok){
                    showMsg('Preencha todas as bolsas');
                }
                return ok;
                   
                
               
			}
			 if(this.project.colaboradores){
                let i = this.project.colaboradores.length;
                let colabs =  this.project.colaboradores;
                while (--i >= 0 && colabs[i].user.id !=0) {
                    if (colabs[i].user.cpf.length == 0 || colabs[i].user.name.length == 0 || colabs[i].user.email.length == 0) {
                        showMsg("Por favor, insira todos colaboradores válidos");
                        return false;
                    }
                    if (document.getElementById('/col-lattes/link-pdf/' + colabs[i].user.cpf).innerText != 'Ver PDF') {
                        showMsg("Por favor, insira os lattes de todos os colaboradores");
                        return false;
                    }
                }
            }
			return true;
        },
        /**
         *  Esta função tem o objetivo de quando usuário esquecer de preencher algum colaborador e
         *  tentar submeter o formulário essa removerá os colaboradores 'lixos'
         * 
        */
        _limparColaboradores(){
            if(!this.project.interdisciplinar){
                this.project.colaboradores=[];
                this.setProject(this.project);
            }
            else if(this.project.colaboradores.length== 0 && this.project.interdisciplinar){
                this.project.interdisciplinar=false;
                this.setProject(this.project);
            }
            else
                this.project.colaboradores.map( (c,index,array) =>{
                    if(!c.user.email){  
                        array.splice(index,1);
                    }
                });
        },
        btnInscricaoOnClick(e){
            let spinner=document.getElementById('spinner');
            e.preventDefault();
            let formData=new FormData();
            if(this.$refs.pdfProjeto.files[0]){
                if(!this.validatePDF(this.$refs.pdfProjeto.files[0])){
                    showMsg("Selecione um arquivo PDF de até 5 MB",400);
                    return false;
                }
                else{
                    formData.append('pdfProjeto',this.$refs.pdfProjeto.files[0]);
                }
                
                
            }
            
            if(!this._validarForm()) return false;
            this._limparColaboradores();
            let area_cnpq_field=$("#area_cnpq").val();
            
            this.project.area_cnpq=area_cnpq_field.replace(/[^0-9]/g,'');
            
            formData.append('projeto',JSON.stringify(this.project));
            formData.append('returnUrl',this.$parent.$props.returnurl);
            let url="/projetos";
            if(this.project.id){
                url="/projetos/"+this.project.id;
                formData.append("_method","PUT");
            }
            spinner.style.display=null;
            $.ajax({
                headers:{
                        'X-CSRF-TOKEN':$('meta[name="csrf-token"]').attr('content')
                },
                url:url,
                data:formData,
                type:"POST",
                processData: false,
                contentType: false,
                success:(response)=>{
                    setTimeout(()=>{
                        location.href=response.url;
                    },1000);
                    spinner.style.display='none';
                    showMsg(response.msg,200);
                },
                error:(response)=>{
                    spinner.style.display='none';
                    showMsg(response.responseText,response.staus);
                }
            });
            
            
        },

        
		

   
    },
    mounted(){
        this.updateField();
        setTimeout( ()=>{
            
            if(!this.project.bolsas.length || Number(this.project.bolsas[0].projeto_id) == 0){
                this.project.bolsas[0]=this._addBolsa();
                this.setProject(this.project);
                this.$forceUpdate();
            }
            
                
        },1000);

        
            
        
    }
    
    
   
}
</script>